import Vue from 'vue'
import App from './App.vue'
// import "@/assets/css/reset.css"
import '@/styles/reset.scss'
import router from './router'

import 'amfe-flexible'
import {
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Pagination,
    Popover,
    Message,
    Loading,
    Empty,
    Carousel,
    CarouselItem
} from 'element-ui';
import {websiteApi} from "@/api/api";

import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
import 'swiper/dist/css/swiper.min.css';
import 'element-ui/lib/theme-chalk/base.css';
import '@/styles/hover.min.css'
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import VueHead from 'vue-head'
Vue.use(VueHead)
Vue.use(Pagination);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Loading);
Vue.use(Empty);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Popover);
Vue.component(CollapseTransition.name, CollapseTransition)

Vue.config.productionTip = false


Vue.prototype.$message = Message;
Vue.prototype.$deviceType = 'miniprogram';
Vue.prototype.$viewer = Viewer;


async function getConfig() {
    const res = await websiteApi.getConfig({
        Action: 'guanying.miniprogram.config.get',
        DeviceType: 'miniprogram'
    })
    // localStorage.setItem('AttachmentDomainName', res.Data.AttachmentDomainName)
    Vue.prototype.$AttachmentDomainName = res.Data.AttachmentDomainName
}


new Vue({
    router,
    render: h => h(App),
    created() {
        getConfig()
    }
}).$mount('#app')
